import React, { FC } from 'react';
import { Spin } from './spin';
import styles from './index.scss';

export const Loading: FC = () => <Spin className={styles.loading} size={40} />;
